import { Component, OnInit } from '@angular/core';
import { DbService } from 'src/app/core/services/db.service';

@Component({
  selector: 'app-show-terms',
  templateUrl: './show-terms.component.html',
  styleUrls: ['./show-terms.component.scss'],
})
export class ShowTermsComponent implements OnInit {
  service;
  constructor(private db: DbService) {}

  async ngOnInit(): Promise<void> {
    const admin = await this.db.toDoc$(`admin/terms`);
    this.service = admin.service;
  }
}
